import _typeof from "@babel/runtime/helpers/typeof";
import { ASSISTANCE_SERVICE_ERROR_CODES } from '../../common/constants/public';
import { isApiError } from '../../common/utils';
export var CONVERSATION_CHANNEL_NOT_FOUND_ERROR = 'CONVERSATION_CHANNEL_NOT_FOUND';
export var ACCEPTABLE_USE_VIOLATIONS_ERROR = 'ACCEPTABLE_USE_VIOLATIONS';

// ************************************************************************************************
// Response data & metadata
// Sent by POST:/chat endpoint
// ************************************************************************************************

// ************************************************************************************************
//  Streaming Messages
// Sent by POST:/chat/stream endpoint
// ************************************************************************************************

/*
NLCreate Stream message types
*/

// ************************************************************************************************
// Other types
// ************************************************************************************************

// All responses should be converted into StreamResponse
// - AssistantMessage -> StreamResponse
// - AgentResponse -> StreamResponse

/**
 * Interface for the Assistance Service.
 */

// ************************************************************************************************
// Type Guards
// ************************************************************************************************

export var isChatMessage = function isChatMessage(message) {
  return isHumanMessage(message) || isAssistantMessage(message) || isStreamResponse(message);
};
export var isHumanMessage = function isHumanMessage(message) {
  return message instanceof Object && message.role === 'HUMAN';
};
export var isAssistantMessage = function isAssistantMessage(message) {
  return message instanceof Object && message.role === 'ASSISTANT';
};
export var isAgentResponse = function isAgentResponse(message) {
  return message instanceof Object && isAssistantMessage(message.message);
};
export var isStreamResponse = function isStreamResponse(message) {
  return message instanceof Object && message.type === 'FINAL_RESPONSE';
};
export var isStreamError = function isStreamError(message) {
  return message instanceof Object && message.type === 'ERROR';
};
export var isStreamAUPError = function isStreamAUPError(message) {
  var _message$message;
  return isStreamError(message) && ((_message$message = message.message) === null || _message$message === void 0 ? void 0 : _message$message.message_template) === ACCEPTABLE_USE_VIOLATIONS_ERROR;
};
export var isStreamAnswerPart = function isStreamAnswerPart(message) {
  return message instanceof Object && message.type === 'ANSWER_PART';
};
export var isStreamResearchBeginningTrace = function isStreamResearchBeginningTrace(message) {
  return message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
};
export var isStreamResearchStepContent = function isStreamResearchStepContent(message) {
  return message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
};
export var isStreamResearchStepTitle = function isStreamResearchStepTitle(message) {
  return message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
};
export var isStreamResearchStepSource = function isStreamResearchStepSource(message) {
  return message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
};
export var isStreamResearchStepCompleted = function isStreamResearchStepCompleted(message) {
  return message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
};
export var isStreamResearchPayload = function isStreamResearchPayload(message) {
  return message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE');
};
export var isStreamTrace = function isStreamTrace(message) {
  // TRACE and research steps are sharing the same type, but we want to separate them
  if (isStreamResearchPayload(message)) {
    return false;
  }
  return message instanceof Object && message.type === 'TRACE';
};
export var isFollowUpMessage = function isFollowUpMessage(message) {
  return message !== undefined && message !== null && _typeof(message) === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
};
export var isChannelNotFoundError = function isChannelNotFoundError(error) {
  var _error$errorAttribute;
  return isApiError(error) && ((_error$errorAttribute = error.errorAttributes) === null || _error$errorAttribute === void 0 ? void 0 : _error$errorAttribute.errorCode) === CONVERSATION_CHANNEL_NOT_FOUND_ERROR;
};
export var isRateLimitedError = function isRateLimitedError(error) {
  return isApiError(error) && error.errorAttributes.statusCode === 429;
};
export var isHipaaError = function isHipaaError(error) {
  return isApiError(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === ASSISTANCE_SERVICE_ERROR_CODES.HAS_HIPAA_ENABLED;
};
export var isConversationChannelDataMessage = function isConversationChannelDataMessage(message) {
  return message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
};

/* TODO: This will evolve as we enrich support for plugins, for the moment
we simply expect to make a direct replacement for `config.space_filters`
with `config.available_plugins['Your-Plugin'].space_filters`. Right now we only support
configuring one plugin, which is the Search-QA-Plugin, which can take the
space_filters configuration, per what our AgentForm expects

Related BE PR: https://bitbucket.org/atlassian/assistance-service/pull-requests/461/aim-367-allow-agents-to-use-plugin-config
*/